export const objectSymmetricDifference = (
  obj1: Record<string, any>,
  obj2: Record<string, any>
): Record<string, any> => {
  const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
  const result: Record<string, any> = {};

  for (const key of allKeys) {
    const inObj1 = key in obj1;
    const inObj2 = key in obj2;

    if (inObj1 !== inObj2) {
      // XOR - true if key is in exactly one object
      result[key] = inObj1 ? obj1[key] : obj2[key];
    }
  }

  return result;
};
